/**
 * Personagem: o resumo da ficha do Mistik Island — atributos, inventário, perícias, o
 * teste, a progressão e as ações — com as fontes reconciliadas e os conflitos entre
 * elas na mesa.
 *
 * <p><b>As condições saíram daqui.</b> Vigor, Concentração, Carga, Energia, o descanso
 * e as condições do corpo e de combate moram em "Condições do Personagem"
 * ({@link ./CondicoesDoPersonagem}) — pedido do Theo, 19/08/2026: a ficha numa página,
 * o que acontece com ela noutra.
 *
 * <p>Duas abas, dois documentos ({@link PaginaEmDuasAbas}): "Beta / Season 1" é a
 * página de trabalho, "Season 2+" guarda o que ficou para depois.
 *
 * <p><b>Não confundir com a tela Ficha</b> (`/game-design/ficha`): lá o time escreve as
 * regras — os bônus de cada atributo, as fórmulas dos secundários, as rolagens da mesa.
 * Aqui está o que os épicos 3, 4 e 5, o GDD v3.3 e a própria Ficha dizem que a ficha É,
 * lado a lado, com a coluna "Decisão do Theo" fechando o que diverge.
 *
 * <p>O conteúdo de fábrica mora em {@link ./conteudoDePersonagem}. O que o time gravar
 * vence inteiro.
 */
import { GRUPOS, GRUPOS_S2, SECOES, SECOES_S2, TABELAS, TABELAS_S2 } from './conteudoDePersonagem';
import { PaginaEmDuasAbas } from './PaginaEmDuasAbas';
import { PAGINAS } from './rascunhoDeGameDesign';

export function Personagem() {
  return (
    <PaginaEmDuasAbas
      beta={{
        chave: PAGINAS.personagemResumo,
        tabelas: TABELAS,
        secoes: SECOES,
        grupos: GRUPOS,
        subtitulo:
          'A ficha até a Season 1: atributos, inventário, perícias, o teste e o que ainda está em disputa entre os épicos, o GDD e o código.',
      }}
      season2={{
        chave: PAGINAS.personagemSeason2,
        tabelas: TABELAS_S2,
        secoes: SECOES_S2,
        grupos: GRUPOS_S2,
        subtitulo: 'O que ficou para depois da Season 1: as perícias marcadas e o backlog do personagem.',
      }}
    />
  );
}
